import { useState } from 'react';
import { Share2, Link2, Check } from 'lucide-react';

const XIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const FacebookIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

function ShareButtons({ title, description, url, image, className = '' }) {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const shareUrl = url || window.location.href;
  const shareTitle = title || document.title;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = shareUrl;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareX = () => {
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}`, '_blank', 'width=600,height=400');
  };

  const shareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank', 'width=600,height=400');
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: shareTitle, text: description || '', url: shareUrl });
        return;
      } catch {}
    }
    setOpen(!open);
  };

  const btnClass = 'flex items-center justify-center w-8 h-8 rounded-full transition-colors';

  return (
    <div className={`relative inline-flex items-center gap-1 ${className}`}>
      <button onClick={nativeShare} className={`${btnClass} bg-white/10 hover:bg-white/20 text-slate-300`} title="공유">
        <Share2 size={14} />
      </button>

      {open && (
        <div className="flex items-center gap-1 animate-fadeIn">
          <button onClick={shareX} className={`${btnClass} bg-white/10 hover:bg-white/20 text-slate-300`} title="X (Twitter)">
            <XIcon size={13} />
          </button>
          <button onClick={shareFacebook} className={`${btnClass} bg-white/10 hover:bg-[#1877f2]/20 text-slate-300 hover:text-[#1877f2]`} title="Facebook">
            <FacebookIcon size={14} />
          </button>
          <button onClick={copyLink} className={`${btnClass} bg-white/10 hover:bg-white/20 ${copied ? 'text-emerald-400' : 'text-slate-300'}`} title="링크 복사">
            {copied ? <Check size={14} /> : <Link2 size={14} />}
          </button>
        </div>
      )}
    </div>
  );
}

export default ShareButtons;
